//
// StyleElement.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var StyleElement = {
    GRAPH_DEFAULTS:0,
    GRAPH_DATA_1:1,
    GRAPH_DATA_2:2,
    GRAPH_DATA_3:3,
    GRAPH_DATA_4:4,
    GRAPH_DATA_5:5,
    GRAPH_DATA_6:6,
    GRAPH_DATA_7:7,
    GRAPH_DATA_8:8,
    GRAPH_DATA_9:9,
    GRAPH_DATA_10:10,
    GRAPH_DATA_11:11,
    GRAPH_DATA_12:12,
    GRAPH_DATA_DEFAULT:13,
    GRAPH_DATA_NODE_1:14,
    GRAPH_DATA_NODE_2:15,
    GRAPH_DATA_NODE_3:16,
    GRAPH_DATA_NODE_4:17,
    GRAPH_DATA_NODE_5:18,
    GRAPH_DATA_NODE_6:19,
    GRAPH_DATA_NODE_7:20,
    GRAPH_DATA_NODE_8:21,
    GRAPH_DATA_NODE_9:22,
    GRAPH_DATA_NODE_10:23,
    GRAPH_DATA_NODE_11:24,
    GRAPH_DATA_NODE_12:25,
    GRAPH_DATA_NODE_DEFAULT:26,
    GRAPH_DATA_NODE_TARGET:27,
    GRAPH_KPI_RANGE_1:28,
    GRAPH_KPI_RANGE_2:29,
    GRAPH_KPI_RANGE_3:30,
    GRAPH_KPI_RANGE_4:31,
    GRAPH_KPI_RANGE_5:32,
    GRAPH_KPI_RANGE_DEFAULT:33,
    GRAPH_KPI_OVERFLOW:34,
    GRAPH_KPI_UNDERFLOW:35,
    GRAPH_OUTLIER:36,
    THREE_COLOR_RAMP:37,
    THREE_COLOR_RAMP_1:38,
    THREE_COLOR_RAMP_2:39,
    THREE_COLOR_RAMP_3:40,
    THREE_COLOR_RAMP_4:41,
    THREE_COLOR_RAMP_KPI:42,
    THREE_COLOR_ALT_RAMP:43,
    THREE_COLOR_ALT_RAMP_1:44,
    THREE_COLOR_ALT_RAMP_2:45,
    THREE_COLOR_ALT_RAMP_3:46,
    THREE_COLOR_ALT_RAMP_4:47,
    THREE_COLOR_ALT_RAMP_KPI:48,
    TWO_COLOR_RAMP:49,
    TWO_COLOR_RAMP_1:50,
    TWO_COLOR_RAMP_2:51,
    TWO_COLOR_RAMP_3:52,
    TWO_COLOR_RAMP_4:53,
    TWO_COLOR_RAMP_5:54,
    TWO_COLOR_RAMP_6:55,
    TWO_COLOR_RAMP_7:56,
    TWO_COLOR_RAMP_8:57,
    TWO_COLOR_RAMP_OTHER:58,
    TWO_COLOR_ALT_RAMP:59,
    TWO_COLOR_ALT_RAMP_1:60,
    TWO_COLOR_ALT_RAMP_2:61,
    TWO_COLOR_ALT_RAMP_3:62,
    TWO_COLOR_ALT_RAMP_4:63,
    TWO_COLOR_ALT_RAMP_5:64,
    TWO_COLOR_ALT_RAMP_6:65,
    TWO_COLOR_ALT_RAMP_7:66,
    TWO_COLOR_ALT_RAMP_8:67,
    TWO_COLOR_ALT_RAMP_OTHER:68,
    ICON_NODE_BACKGROUND:69,
    ICON_NODE_END:70,
    ICON_NODE_GATEWAY_EXCLUSIVE:71,
    ICON_NODE_GATEWAY_INCLUSIVE:72,
    ICON_NODE_START:73,
    ICON_NODE_TIMER:74,
    GRAPH_AXIS_LINES:75,
    GRAPH_REFERENCE:76,
    GRAPH_GRID_LINES:77,
    GRAPH_MINOR_GRID_LINES:78,
    GRAPH_OUTLINES:79,
    GRAPH_OUTLINES_PERIMETER:80,
    GRAPH_OUTLINES_UNFILLED:81,
    GRAPH_OUTLINES_NODE:82,
    GRAPH_BORDER_LINES:83,
    GRAPH_TITLE_TEXT:84,
    GRAPH_FOOTNOTE_TEXT:85,
    GRAPH_DATA_TEXT:86,
    GRAPH_KEY_TEXT:87,
    GRAPH_KEY_OUTLINE:88,
    GRAPH_KEY_FRAME_VALUE:89,
    GRAPH_LABEL_TEXT:90,
    GRAPH_LABEL2_TEXT:91,
    GRAPH_VALUE_TEXT:92,
    GRAPH_CALLOUT_LINE:93,
    GRAPH_KPI_RANGE_TEXT:94,
    GRAPH_KPI_VALUE_TEXT:95,
    GRAPH_BACKGROUND:96,
    GRAPH_WALLS:97,
    GRAPH_FLOOR:98,
    GRAPH_INSIDE_LEGEND_BACKGROUND:99,
    GRAPH_LEGEND_BACKGROUND:100,
    GRAPH_HEADER_BACKGROUND:101,
    GRAPH_FIT_LINE:102,
    GRAPH_FIT_LINE_2:103,
    GRAPH_PREDICTION_LINE:104,
    GRAPH_CONFIDENCE:105,
    GRAPH_CONFIDENCE_2:106,
    GRAPH_PREDICTION_LIMIT:107,
    GRAPH_ERROR:108,
    GRAPH_BOX_MEDIAN:109,
    GRAPH_BOX_MEAN:110,
    GRAPH_BOX_WHISKER:111,
    GRAPH_ANNO_LINE:112,
    GRAPH_ANNO_TEXT:113,
    GRAPH_ANNO_SHAPE:114,
    GRAPH_SELECTION:115,
    GRAPH_FOCUS:116,
    GRAPH_FOCUS_BACKGROUND:117,
    GRAPH_MISSING:118,
    GRAPH_CONTROL_LIMITS:119,
    GRAPH_RUN_TEST:120,
    GRAPH_STARS:121,
    GRAPH_CLIPPING:122,
    GRAPH_RANGE_FILL:123,
    GRAPH_DROP_SHADOW:124,
    GRAPH_BOX:125,
    GRAPH_HISTOGRAM:126,
    GRAPH_BAR:127,
    GRAPH_PIE:128,
    GRAPH_INSET_PIE:129,
    GRAPH_BUBBLE:130,
    GRAPH_SCATTER:131,
    GRAPH_HIGHLOW:132,
    GRAPH_HEATMAP:133,
    GRAPH_ICICLE:134,
    GRAPH_WATERFALL:135,
    GRAPH_SCHEDULE:136,
    GRAPH_TIMESERIES:137,
    GRAPH_SERIES:138,
    GRAPH_LINECHART:139,
    GRAPH_BAND:140,
    GRAPH_DECISIONTREE:141,
    GRAPH_LINEAGE:142,
    GRAPH_NETWORK:143,
    GRAPH_PROCESSFLOW:144,
    GRAPH_SANKEY:145,
    GRAPH_ELLIPSE:146,
    GRAPH_POLYGON:147,
    GRAPH_CONNECT_LINE:148,
    GRAPH_UNICODE_TEXT:149,
    GRAPH_OVERFLOW:150,
    GRAPH_UNDERFLOW:151,
    GRAPH_OUT_OF_RANGE:152,
    GRAPH_DATA_STYLE_INITIAL:153,
    GRAPH_DATA_STYLE_FINAL:154,
    GRAPH_DATA_STYLE_OTHER:155,
    GRAPH_ROW_COLUMN_AXIS_CELL_FILL:156,
    GRAPH_TIP_TEXT:157,
    GRAPH_TIP_FILL:158,
    GRAPH_MILESTONE:159,
    GRAPH_WEEKEND:160,
    GRAPH_CONTOUR:161,
    GRAPH_BLOCK:162,
    GRAPH_ALT_BLOCK:163,
    GRAPH_BLOCK_HEADER:164,
    GRAPH_CUT_LINE:165,
    GRAPH_TABLE_GRIDLINES:166,
    GRAPH_TABLE_HEADER_FILL:167,
    GRAPH_TABLE_HEADER_TEXT:168,
    GRAPH_TABLE_DATA_FILL:169,
    GRAPH_TABLE_DATA_TEXT:170,
    GRAPH_DIAGRAM_GRID_LINES:171,
    GRAPH_NODE_LINK_DIAGRAM:172,
    GRAPH_NODE:173,
    GRAPH_NODE_TITLE:174,
    GRAPH_NODE_LABEL:175,
    GRAPH_NODE_INPUT_LABEL:176,
    GRAPH_NODE_DETAILS:177,
    GRAPH_NODE_TEXT:178,
    GRAPH_NODE_LINK_LABEL:179,
    GRAPH_NODE_GROUP_OPEN:180,
    GRAPH_NODE_GROUP_CLOSED:181,
    GRAPH_NODE_GROUP_TITLE:182,
    GRAPH_NODE_WINDOW_GROUP_CONTENT_AREA:183,
    GRAPH_LINK:184,
    GRAPH_CROSSOVER_LINK:185,
    GRAPH_HIGHLIGHTED_LINK:186,
    GRAPH_HIGHLIGHTED_NODE:187,
    GRAPH_STATUS_BACKGROUND:188,
    GRAPH_STATUS_CLUSTERED:189,
    GRAPH_STATUS_COMPLETE:190,
    GRAPH_STATUS_ERROR:191,
    GRAPH_STATUS_IMPORTANT:192,
    GRAPH_STATUS_INCOMPLETE:193,
    GRAPH_STATUS_INCOMPLETE_IN_PROGRESS:194,
    GRAPH_STATUS_INFORMATION:195,
    GRAPH_STATUS_LOCKED:196,
    GRAPH_STATUS_MEDIUM_PRIORITY:197,
    GRAPH_STATUS_NEUTRAL:198,
    GRAPH_STATUS_PROGRESS:199,
    GRAPH_STATUS_SCHEDULED:200,
    GRAPH_STATUS_STOPPED:201,
    GRAPH_STATUS_STOPPING:202,
    GRAPH_STATUS_WARNING:203,
    GRAPH_ANIMATED_PROGRESS_INDICATOR:204,
    GRAPH_NOTE_YELLOW:205,
    GRAPH_NOTE_PINK:206,
    GRAPH_NOTE_BLUE:207,
    GRAPH_NOTE_TEXT:208,
    GRAPH_GROUP:209,
    GRAPH_GROUP_BACKGROUND:210,
    GRAPH_GROUP_TITLE:211,
    GRAPH_GROUP_NODE:212,
    GRAPH_LEVEL_GROUP_LABEL:213,
    GRAPH_LEVEL_GROUP_LINE:214,
    GRAPH_LEVEL_LABEL:215,
    GRAPH_SKIN:216,
    GRAPH_OVERVIEW_BACKGROUND:217,
    GRAPH_OVERVIEW_BORDER_LINES:218,
    GRAPH_OVERVIEW_VIEWPORT_BACKGROUND:219,
    GRAPH_OVERVIEW_VIEWPORT_BORDER_LINES:220,
    GRAPH_OVERVIEW_FILTER:221,
    GRAPH_OVERVIEW_AXIS:222,
    GRAPH_OVERVIEW_AXIS_FILTER:223,
    GRAPH_LINEAR_AXIS:224,
    GRAPH_LOG_AXIS:225,
    GRAPH_TIME_AXIS:226,
    GRAPH_DISCRETE_AXIS:227,
    GRAPH_CONTINUOUS_LEGEND:228,
    GRAPH_DISCRETE_LEGEND:229,
    GRAPH_SIZE_LEGEND:230,
    GRAPH_LAYOUT_OVERLAY:231,
    GRAPH_LAYOUT_LATTICE:232,
    GRAPH_LAYOUT_DATA_MATRIX:233,
    GRAPH_LAYOUT_DATA_PANEL:234,
    GRAPH_CELL_SEPARATOR_LINES:235,
    GRAPH_DATA_MATRIX_BORDER_LINES:236,
    GRAPH_ZOOM_SCROLLBAR_END_HANDLE:237,
    GRAPH_ZOOM_SCROLLBAR_THUMB:238,
    GRAPH:239,
    GRAPH_ANIMATION_CONTROL_PANEL:240,
    GRAPH_GAUGE_INDICATOR:241,
    GRAPH_OVERPLOTTING:242,
    GRAPH_OVERLAY_DATA_INSET:243,
    GRAPH_GEO_ROUTE_MAIN_PATH:244,
    GRAPH_GEO_ROUTE_CENTER_PATH:245,
    GRAPH_GEO_ROUTE_PATH_OUTER_PERIMETER:246,
    GRAPH_GEO_ROUTE_PATH_INNER_PERIMETER:247,
    GRAPH_GEO_ROUTE_PATH_SELECTION:248,
    GRAPH_GEO_ROUTE_PATH_HOVER:249,
    GRAPH_GEO_ROUTE_PATH_OUTER_PERIMETER_INVERSE:250,
    GRAPH_GEO_ROUTE_PATH_FOCUS:251,
    GRAPH_GEO_ROUTE_PATH_FOCUS_PERIMETER:252,
    GRAPH_GEO_ROUTE_POINT:253,
    GRAPH_GEO_ROUTE_POINT_LABEL:254,
    GRAPH_GEO_PIN:255,
    GRAPH_GEO_PIN_LABEL:256,
    GRAPH_GEO_PIN_ICON:257,
    GRAPH_GEO_SEARCH_PIN:258,
    GRAPH_GEO_CENTROID_POINT:259,
    GRAPH_GEO_AREA:260,
    GRAPH_GEO_AREA_OUTER_PERIMETER:261,
    GRAPH_GEO_AREA_INNER_PERIMETER:262,
    GRAPH_GEO_AREA_INNER_PERIMETER_THICK:263,
    GRAPH_GEO_AREA_OUTER_HOVER:264,
    GRAPH_GEO_AREA_OUTER_PERIMETER_INVERSE:265,
    GRAPH_GEO_AREA_SELECTION:266,
    GRAPH_GEO_AREA_OUTER_SELECTION:267,
    GRAPH_GEO_AREA_FOCUS:268,
    GRAPH_GEO_AREA_FOCUS_PERIMETER:269,
    GRAPH_GEO_REGION_EMPTY:270,
    GRAPH_ZONE_A:271,
    GRAPH_ZONE_B:272,
    GRAPH_ZONE_C:273,
    GRAPH_PHASE_BOX:274,
    GRAPH_SLIDER:275,
    GRAPH_MENU:276,
    GRAPH_THIN_LINE:277,
    GRAPH_DATA_STYLE_INCREASING:278,
    GRAPH_DATA_STYLE_DECREASING:279,
    GRAPH_BASEMAP:280,
    GRAPH_MAP_REGION_LAYER:281,
    REPORT:282,
    TITLESTYLE:283,
    PROMPTBAR:284,
    COMBOBOX:285,
    CHECKBOXLIST:286,
    SLIDER:287,
    BUTTONBAR:288,
    RADIOBUTTON:289,
    TEXTINPUT:290,
    HYPERLINK:291,
    HYPERLINKVISITED:292,
    DROPZONE:293,
    HOVER:294,
    SELECTED:295,
    TABLE:296,
    HEADER:297,
    DATA:298,
    BRUSH:299,
    ROW_HEADER:300,
    COLUMN_HEADER:301,
    ROW_HEADER_LABEL:302,
    COLUMN_HEADER_LABEL:303,
    MEASURE_HEADER:304,
    TOTALS:305,
    SUBTOTALS:306,
    TABLE_HEADER:307,
    TABLE_TOTALS:308,
    TABLE_TABLE:309,
    TABLE_DATA:310,
    TABLE_SELECTED:311,
    TABLE_BRUSH:312,
    CROSSTAB_TABLE:313,
    CROSSTAB_DATA:314,
    CROSSTAB_HEADER:315,
    CROSSTAB_TOTALS:316,
    CROSSTAB_SUBTOTALS:317,
    CROSSTAB_SELECTED:318,
    CROSSTAB_BRUSH:319,
    ZOOM_SCROLLBAR:320,
    STACK_NAVIGATION_CONTROL:321,
    STACK_CONTAINER:322,
    REPORT_ELEMENT_CONTAINER:323,
    REPORT_PAGE_PADDING:324,
    CONTAINER:325,
    SCROLLBAR:326,
    TABLE_SCROLLBAR:327,
    CROSSTAB_SCROLLBAR:328,
    TEXT_SCROLLBAR:329,
    TEXTSTYLE:330,
    H1:331,
    H2:332,
    H3:333,
    H4:334,
    H5:335,
    H6:336,
    INVALID:337,
    MATCHES_ALL:338
};
export default StyleElement;
